/**
 * @generated SignedSource<<112134a474e67c76ee5e3ab811fec25a>>
 * @relayHash 518c3d1defa9f1d629cf7ea45978a8c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6e29afdec7f830b550a6da040df2ec6ec840f26621dbd327fa6d418efcbe9f1a

import type { ConcreteRequest } from 'relay-runtime';
export type SiteNameKnowledgeQuery$variables = {
  cloudIds?: ReadonlyArray<string> | null;
};
export type SiteNameKnowledgeQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudId: string | null;
    readonly cloudUrl: AGG$URL | null;
  } | null> | null;
};
export type SiteNameKnowledgeQuery = {
  response: SiteNameKnowledgeQuery$data;
  variables: SiteNameKnowledgeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "cloudId"
      },
      {
        "kind": "ScalarField",
        "name": "cloudUrl"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SiteNameKnowledgeQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SiteNameKnowledgeQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6e29afdec7f830b550a6da040df2ec6ec840f26621dbd327fa6d418efcbe9f1a",
    "metadata": {},
    "name": "SiteNameKnowledgeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cca5d4d7642f09fdf5aa4708ebaae400";

export default node;
